import { createContext, useContext, useEffect, useState, useCallback } from "react";
// import apiRequest from "../lib/apiRequest";
import encryptedapiRequest from "../lib/encryptedapiRequest";

const MasterDataContext = createContext();

export const MasterDataProvider = ({ children }) => {
  // --- Master datasets ---
  const [colonies, setColonies] = useState([]);
  const [transactionTypes, setTransactionTypes] = useState([]);
  const [reqtransactionTypes, setReqTransactionTypes] = useState([]);
  const [cities, setCities] = useState([]);



  const [propertyTypes, setPropertyTypes] = useState([]);
  const [clientTypes, setClientTypes] = useState([]);
  const [generalFeatures, setGeneralFeatures] = useState([]);
  const [sizes,setSizes]=useState([]);
  const [userTypes,setUserTypes]=useState([]);
  const [clientContactTypes,setClientContactTypes]=useState([]);
  const [developers, setDevelopers] = useState([]);




  // --- Ready flags for module-level refresh ---
  const [coloniesReady, setColoniesReady] = useState(false);
  const [transactionTypesReady, setTransactionTypesReady] = useState(false);
  const [reqtransactionTypesReady, setReqTransactionTypesReady] = useState(false);
  const [citiesReady, setCitiesReady] = useState(false);
  


  const [propertyTypesReady, setPropertyTypesReady] = useState(false);
  const [clientTypesReady, setClientTypesReady] = useState(false);
  const [generalFeaturesReady, setGeneralFeaturesReady] = useState(false);
  const [sizesReady,setSizesReady]=useState(false);   
  const [userTypesReady,setUserTypesReady]=useState(false);
  const [clientContactTypesReady,setClientContactTypesReady]=useState(false);
  const [developersReady, setDevelopersReady] = useState(false);



  // --- Initial load: fetch all master data ---
  const fetchAllMasters = useCallback(async () => {
    // Temporarily mark all as not ready
    setColoniesReady(false);
    setTransactionTypesReady(false);
    setReqTransactionTypesReady(false);
    setCitiesReady(false);


    setPropertyTypesReady(false);
    setClientTypesReady(false);  // changed
    setGeneralFeaturesReady(false);
    setSizesReady(false);
    setUserTypesReady(false);
    setClientContactTypesReady(false);
    setDevelopersReady(false);

    try {

      // const secret="=!rajeshkhetrapl-kashish-shanta="

      const response = await encryptedapiRequest.get("/masters/allmasters"); // single API call
      const data = response.data || {};

      setColonies(data.Colonies || []);
      setColoniesReady(true);

      setTransactionTypes(data.SaleTransactionTypes || []);
      setTransactionTypesReady(true);

      setReqTransactionTypes(data.RequirementTransactionTypes || []);
      setReqTransactionTypesReady(true);

      setCities(data.Cities || []);
      setCitiesReady(true);

      setPropertyTypes(data.PropertyTypes || []);
      setPropertyTypesReady(true);


      setClientTypes(data.ClientTypes || []);
      setClientTypesReady(true);

      setGeneralFeatures(data.GeneralTags || []); 
      setGeneralFeaturesReady(true);

      setSizes(data.Sizes || []); 
      setSizesReady(true);

      setUserTypes(data.UserTypes || []);
      setUserTypesReady(true);

      setClientContactTypes(data.ClientContactTypes || []);
      setClientContactTypesReady(true);

      setDevelopers(data.Developers || []);
      setDevelopersReady(true);

    } catch (err) {
      console.error("Failed to fetch master data:", err);

      setColonies([]);
      setTransactionTypes([]);
      setReqTransactionTypes([]);          
      setCities([]);

      setPropertyTypes([]);
      setClientTypes([]);
      setGeneralFeatures([]);
      setSizes([]);
      setUserTypes([]);
      setClientContactTypes([]);
      setDevelopers([]);

      setColoniesReady(true);
      setTransactionTypesReady(true);
      setReqTransactionTypesReady(true);
      setCitiesReady(true);


      setPropertyTypesReady(true);
      setClientTypesReady(true);
      setGeneralFeaturesReady(true);
      setSizesReady(true);
      setUserTypesReady(true);
      setClientContactTypesReady(true);
      setDevelopersReady(true);


    }
  }, []);

  // --- Individual refresh functions ---
  const refreshColonies = useCallback(async () => {
    setColoniesReady(false);
    try {
      const response = await encryptedapiRequest.get("/masters/colonies");
      setColonies(response.data || []);
    } catch (err) {
      console.error("Failed to refresh colonies:", err);
    } finally {
      setColoniesReady(true);
    }
  }, []);

  const refreshTransactionTypes = useCallback(async () => {
    setTransactionTypesReady(false);
    try {
      const response = await encryptedapiRequest.get("/masters/transactiontypes");
      setTransactionTypes(response.data || []);
    } catch (err) {
      console.error("Failed to refresh transaction types:", err);
    } finally {
      setTransactionTypesReady(true);
    }
  }, []);







  const refreshReqTransactionTypes = useCallback(async () => {
    setReqTransactionTypesReady(false);
    try {
      const response = await encryptedapiRequest.get("/masters/reqtransactiontypes");
      setReqTransactionTypes(response.data || []);
    } catch (err) {
      console.error("Failed to refresh transaction types:", err);
    } finally {
      setReqTransactionTypesReady(true);
    }
  }, []);



  const refreshCities = useCallback(async () => {
    setCitiesReady(false);
    try {
      const response = await encryptedapiRequest.get("/masters/cities");
      setCities(response.data || []);
    } catch (err) {
      console.error("Failed to refresh colonies:", err);
    } finally {
      setCitiesReady(true);
    }
  }, []);





  const refreshPropertyTypes = useCallback(async () => {
    setPropertyTypesReady(false);
    try {
      const response = await encryptedapiRequest.get("/masters/propertytypes");
      setPropertyTypes(response.data || []);
    } catch (err) {
      console.error("Failed to refresh property types:", err);
    } finally {
      setPropertyTypesReady(true);
    }
  }, []);



  // --- Individual refresh functions ---
  const refreshClientTypes = useCallback(async () => {
    setClientTypesReady(false);
    try {
      const response = await encryptedapiRequest.get("/masters/clienttypes");
      setClientTypes(response.data || []);
    } catch (err) {
      console.error("Failed to refresh clienttypes:", err);
    } finally {
      setClientTypesReady(true);
    }
  }, []);


  // --- Individual refresh functions ---
  const refreshGeneralFeatures = useCallback(async () => {
    setGeneralFeaturesReady(false);
    try {
      const response = await encryptedapiRequest.get("/masters/general");
      setGeneralFeatures(response.data || []);
    } catch (err) {
      console.error("Failed to refresh generalfeatures:", err);
    } finally {
      setGeneralFeaturesReady(true);
    }
  }, []);


  // --- Individual refresh functions ---
  const refreshSizes = useCallback(async () => {
    setSizesReady(false);
    try {
      const response = await encryptedapiRequest.get("/masters/sizes");
      setSizes(response.data || []);
    } catch (err) {
      console.error("Failed to refresh sizes:", err);
    } finally {
      setSizesReady(true);
    }
  }, []);


  // --- Individual refresh functions ---
  const refreshUserTypes = useCallback(async () => {
    setUserTypesReady(false);
    try {
      const response = await encryptedapiRequest.get("/masters/usertypes");
      setUserTypes(response.data || []);
    } catch (err) {
      console.error("Failed to refresh usertypes:", err);
    } finally {
      setUserTypesReady(true);
    }
  }, []);



    // --- Individual refresh functions ---
  const refreshClientContactTypes = useCallback(async () => {
    setClientContactTypesReady(false);
    try {
      const response = await encryptedapiRequest.get("/masters/clientcontacttypes");
      setClientContactTypes(response.data || []);
    } catch (err) {
      console.error("Failed to refresh clientcontacttypes:", err);
    } finally {
      setClientContactTypesReady(true);
    }
  }, []);

  // --- Individual refresh functions ---
  const refreshDevelopers = useCallback(async () => {
    setDevelopersReady(false);
    try {
      const response = await encryptedapiRequest.get("/projects/developers");
      setDevelopers(response.data || []);
    } catch (err) {
      console.error("Failed to refresh Developers:", err);
    } finally {
      setDevelopersReady(true);
    }
  }, []);





const FindAndAddMaster = useCallback(
  async ({ masterArray,tableName, fieldName, value, refreshFunction }) => {
    if (!value?.trim()) return;

    // console.log("parameters: ",masterArray,tableName, fieldName, value, refreshFunction);

    // Get current data array dynamically
    const masterMap = {
      propertyTypes,
      colonies,
      cities,
      transactionTypes,
      reqtransactionTypes,
      clientTypes,
      generalFeatures,
      sizes,
      userTypes,
      clientContactTypes,
      developers,
    };

    const currentArray = masterMap[masterArray];

    if (!currentArray) {
      console.error(`Invalid master: ${masterArray}`);
      return;
    }

    // ✅ Check if already exists
    const exists = currentArray.some(
      (item) =>
        item[fieldName]?.toLowerCase() === value.toLowerCase()
    );

    // console.log("value ",value , "exists in array",currentArray,exists);
    if (exists) return; // already exists

    try {
      // ✅ Call your PHP API
      const formData = new FormData();
      formData.append("tablename", tableName);
      formData.append("fieldname", fieldName);
      formData.append("value", value);


      // console.log("now firing /masters/find")
      await encryptedapiRequest.post("/masters/find", formData);

      // ✅ Refresh after insert
      if (refreshFunction) {
        await refreshFunction();
      }
    } catch (err) {
      console.error("FindAndAddMaster failed:", err);
    }
  },
  [
    propertyTypes,
    colonies,
    cities,
    transactionTypes,
    reqtransactionTypes,
    clientTypes,
    generalFeatures,
    sizes,
    userTypes,
    clientContactTypes,
    developers,
  ]
);





  // --- Initial fetch ---
  useEffect(() => {
    fetchAllMasters();
  }, [fetchAllMasters]);

  // --- Context value ---
  const value = {
    colonies,
    transactionTypes,
    reqtransactionTypes,
    cities,

    propertyTypes,
    clientTypes,
    generalFeatures,
    sizes,
    userTypes,
    clientContactTypes,
    developers,

    coloniesReady,
    transactionTypesReady,
    reqtransactionTypesReady,
    citiesReady,


    propertyTypesReady,
    clientTypesReady,
    generalFeaturesReady,
    sizesReady,
    userTypesReady,
    clientContactTypesReady,
    developersReady,


    // refresh functions
    refreshMasters: fetchAllMasters,
    refreshColonies,
    refreshTransactionTypes,
    refreshPropertyTypes,
    refreshCities,
    refreshClientTypes,
    refreshGeneralFeatures,
    refreshSizes,
    refreshUserTypes,
    refreshClientContactTypes,
    refreshReqTransactionTypes,
    refreshDevelopers,
    FindAndAddMaster,

  };
  return <MasterDataContext.Provider value={value}>{children}</MasterDataContext.Provider>;
};

export const useMasterData = () => useContext(MasterDataContext);
